import {
    FETCH_FORECASTS_REQUEST,
    FETCH_FORECASTS_SUCCESS,
    FETCH_FORECASTS_FAILURE,
    FETCH_ACTIVITY_FORECASTS_REQUEST,
    FETCH_ACTIVITY_FORECASTS_SUCCESS,
    FETCH_ACTIVITY_FORECASTS_FAILURE,
    FETCH_ACTIVITY_FORECAST_BY_ID_REQUEST,
    FETCH_ACTIVITY_FORECAST_BY_ID_SUCCESS,
    FETCH_ACTIVITY_FORECAST_BY_ID_FAILURE,
} from '../actions/forecastsActions';

const initialState = {
    list: { data: null, loading: false, error: null },
    activityForecasts: { data: null, loading: false, error: null },
    selectedActivityForecast: { data: null, loading: false, error: null },
};

const forecastsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_FORECASTS_REQUEST:
            return { ...state, list: { data: state.list.data, loading: true, error: null } };
        case FETCH_FORECASTS_SUCCESS:
            return { ...state, list: { data: action.payload, loading: false, error: null } };
        case FETCH_FORECASTS_FAILURE:
            return { ...state, list: { data: null, loading: false, error: action.payload } };
        case FETCH_ACTIVITY_FORECASTS_REQUEST:
            return { ...state, activityForecasts: { data: state.activityForecasts.data, loading: true, error: null } };
        case FETCH_ACTIVITY_FORECASTS_SUCCESS:
            return { ...state, activityForecasts: { data: action.payload, loading: false, error: null } };
        case FETCH_ACTIVITY_FORECASTS_FAILURE:
            return { ...state, activityForecasts: { data: null, loading: false, error: action.payload } };
        case FETCH_ACTIVITY_FORECAST_BY_ID_REQUEST:
            return { ...state, selectedActivityForecast: { data: state.selectedActivityForecast.data, loading: true, error: null } };
        case FETCH_ACTIVITY_FORECAST_BY_ID_SUCCESS:
            return { ...state, selectedActivityForecast: { data: action.payload, loading: false, error: null } };
        case FETCH_ACTIVITY_FORECAST_BY_ID_FAILURE:
            return { ...state, selectedActivityForecast: { data: null, loading: false, error: action.payload } };
        default:
            return state;
    }
};

export default forecastsReducer;




